<template>
  <input type="hidden" :name="csrfName" :value="csrf" />
</template>

<script>
export default {
  data() {
    return {
      csrfName: '',
      csrf: '',
    };
  },
  mounted() {
    this.csrfName = document.querySelector('meta[name=csrf-param]').getAttribute('content');
    this.csrf = document.querySelector('meta[name=csrf-token]').getAttribute('content');
  },
};
</script>
